module.exports = __webpack_public_path__ + "static/media/nucleo-outline.8ebec31f.woff2";